<template>
    <div class="button-wrap">
        <div class="row" v-if="backOnly">
            <div class="col back">
                <button class="button button--ghost-white" @click="onBack">Back To Questions</button>
            </div>
        </div>
        <div v-else>
            <div class="row" v-if="! isResultPage">
                <div v-if="back" class="col back">
                    <button class="button button--ghost-white" @click="onBack">Back</button>
                </div>
                <div class="col forward" :class="[!back ? 'center' : 'forward']">
                    <button class="button button--solid" @click="onNext" :disabled="!valid">Next</button>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col restart">
                    <button class="button button--ghost-white" @click="onRestart">Start Again</button>
                </div>
                <div class="col">
                    <a class="button button--solid" :href="callFormLink" @click="trackCallButton(callFormLink)">Call Me
                        Back</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AnswerPreload from './../../../services/AnswerPreload';
    import VueScrollTo from 'vue-scrollto'
    const FORM_URL = "/electric-car-van-ready-tool/contact";
    const ADMIN_FIELD_NAME = "Maturity_Tool_URL";
    export default {
        name: "NavButtons",
        props: ["back", "answer", "backOnly"],
        methods: {
            onNext() {
                if (this.valid) {
                    this.$gtag.logStep(
                        'Question',
                        'EV Maturity Tool - ' + this.currentPage
                    );
                    this.$store.dispatch('next');
                    this.$emit('sent');
                    VueScrollTo.scrollTo('#app', 1);
                }
            },
            onBack() {
                this.$store.dispatch("back");
            },
            onRestart() {
                AnswerPreload.clearCookie();
                VueScrollTo.scrollTo('#app', 1);
                this.$store.dispatch("restart");

            },
            trackCallButton(url){
                this.$gtag.logCTA('EV Maturity Tool - Call Me Back - ' + url);
            }
        },
        computed: {
            valid() {
                if (typeof this.$store.state.current !== 'number') {
                    return true;
                } else if (this.answer != null) {
                    return true;
                }

                return false;
            },
            isResultPage() {
                return this.$store.state.current === 'result'
            },
            adminUrl() {
                return AnswerPreload.getAdminUrl(this.$store);
            },
            callFormLink() {
                return FORM_URL
                    + "?"
                    + ADMIN_FIELD_NAME
                    + "="
                    + encodeURIComponent(this.adminUrl);
            },
            currentPage() {
                return this.$store.state.current
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .button-wrap
        margin 5rem 0

    .forward
        text-align: right

    .center
        text-align: center

    .restart
        text-align: right

</style>